import { colors, TertiaryLink, ToastType } from '@everlywell/leaves';
import React from 'react';
import styled from 'styled-components';
import { ANALYTICS } from 'utils/constants/analytics';
import { RESULTS_ROOT } from 'utils/constants/urls';

import { capitalize } from '../../utils/helpers';
import { NotificationType } from '../../utils/types';

const StyledLink = styled(TertiaryLink)`
  color: ${colors.black};
`;

const NOTIFICATIONS = {
  PAYMENT_FAILED: (source: string): NotificationType => ({
    id: 'PAYMENT_FAILED',
    message: 'Payment Failed',
    type: ToastType.ERROR,
    persist: false,
    details: (
      // To-Do: Remove once TertiaryLink is updated to accept 'target' prop
      <StyledLink
        href={`${RESULTS_ROOT}/account/settings#paymentSettings`}
        target="_blank"
      >
        Update Payment Info
      </StyledLink>
    ),
    mixpanelLabel: 'Payment Failure',
    onlyShowOnce: true,
    source,
  }),
  ALREADY_A_MEMBER: (source: string, type: string): NotificationType => ({
    id: 'ALREADY_A_MEMBER',
    message: `You are already a ${capitalize(
      type === 'sti' ? 'current' : type,
    )} member!`,
    type: ToastType.WARNING,
    persist: false,
    mixpanelLabel: 'AlreadyMember',
    source,
  }),
  MBRS_INTAKE_CREATE_ACCOUNT_SUCCESS: (source: string): NotificationType => ({
    id: 'INTAKE_CREATE_ACCOUNT_SUCCESS',
    message: `Your account has been successfully created!`,
    type: ToastType.SUCCESS,
    persist: false,
    mixpanelLabel: 'IntakeSuccess', // TODO: Update this label and copy
    source,
  }),
  MBRS_INTAKE_CREATE_ACCOUNT_FAILURE: (source: string): NotificationType => ({
    id: 'INTAKE_CREATE_ACCOUNT_FAILURE',
    message: `Account creation failed.`,
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: 'IntakeFailure', // TODO: Update this label and copy
    source,
  }),
  MBRS_INTAKE_COMPLETE_STORE_FAILURE: (source: string): NotificationType => ({
    id: 'COMPLETE_STORE_FAILURE',
    message: `There was a problem handling your request`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: 'IntakeFailure', // TODO: Update this label and copy
    source,
  }),
  MBRS_INTAKE_STRIPE_INTENT_FAILURE: (source: string): NotificationType => ({
    id: 'STRIPE_INTENT_FAILURE',
    message: `There was a problem with your card`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: 'IntakeFailure', // TODO: Update this label and copy
    source,
  }),
  MBRS_INTAKE_PAYMENT_COMPLETE: (source: string): NotificationType => ({
    id: 'PAYMENT_COMPLETE',
    message: 'A confirmation email has been sent to you',
    details: 'Membership details are in this email',
    type: ToastType.SUCCESS,
    persist: false,
    mixpanelLabel: 'IntakeFailure', // TODO: Update this label and copy
    source,
  }),
  MBRS_INTAKE_CONSUMER_CREATION_FAILURE: (
    source: string,
  ): NotificationType => ({
    id: 'CONSUMER_CREATION_FAILURE',
    message: `An error occurred`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: 'ConsumerCreationFailed', // TODO: Update this label and copy
    source,
  }),
  MBRS_CREDIT_REDEMPTION_FAILURE: (source: string): NotificationType => ({
    id: 'CREDIT_REDEMPTION_FAILURE',
    message: `There was a problem claiming your test`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: 'CreditRedemptionFailure', // TODO: Update this label and copy
    source,
  }),
  MBRS_CREDIT_REDEMPTION_SUCCESS: (source: string): NotificationType => ({
    id: 'CREDIT_REDEMPTION_SUCCESS',
    message: 'Your test has been successfully claimed',
    type: ToastType.SUCCESS,
    persist: false,
    mixpanelLabel: 'CreditRedemptionSuccess', // TODO: Update this label and copy
    source,
  }),

  MBRS_TEST_PLAN_ITEM_CREATION_FAILURE: (source: string): NotificationType => ({
    id: 'TEST_PLAN_ITEM_CREATION_FAILURE',
    message: `There was a problem adding your test to your queue`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: ANALYTICS.LABELS.TEST_PLAN.api.add,
    source,
  }),
  MBRS_TEST_PLAN_ITEM_CREATION_SUCCESS: (source: string): NotificationType => ({
    id: 'TEST_PLAN_ITEM_CREATION_SUCCESS',
    message: 'Your test has been successfully added to your queue',
    type: ToastType.SUCCESS,
    persist: false,
    mixpanelLabel: ANALYTICS.LABELS.TEST_PLAN.api.add,
    source,
  }),

  MBRS_REMOVE_TEST_PLAN_ITEM_FAILURE: (source: string): NotificationType => ({
    id: 'REMOVE_TEST_PLAN_ITEM_FAILURE',
    message: `There was a problem REMOVING your test of your queue`,
    details: 'Please try again',
    type: ToastType.ERROR,
    persist: false,
    mixpanelLabel: ANALYTICS.LABELS.TEST_PLAN.api.remove,
    source,
  }),
  MBRS_REMOVE_TEST_PLAN_ITEM_CREATION_SUCCESS: (
    source: string,
  ): NotificationType => ({
    id: 'REMOVE_TEST_PLAN_ITEM_SUCCESS',
    message: 'Your test has been successfully removed from your queue',
    type: ToastType.SUCCESS,
    persist: false,
    mixpanelLabel: ANALYTICS.LABELS.TEST_PLAN.api.remove,
    source,
  }),
};

export default NOTIFICATIONS;
